<!--https://github.com/northwalker/vue-hotel-datepicker-->

<template>
	<div
		:class="[
			mobile.toLowerCase(),
			dropdown ? 'vhd-container--dropdown' : '',
			lightTheme ? 'vhd-container--lightTheme' : '',
			singleCalendar ? 'vhd-container--single' : '',
			accordionTheme ? 'vhd-container--accordionTheme' : ''
		]"
		class="vhd-container"
	>
		<!-- <input v-model="value"
          :placeholder="placeholder"
          type="text" class="vhd-input" aria-label="vue-hotel-datepicker-input"
          @mousedown.prevent="toggle"
    @focus.prevent="toggle">-->
		<div class="vhd-picker">
			<div class="vhd-calendar">
				<!--<div class="vhd-calendar-header">
					<a class="close" @click="close">
						<span>X</span>
					</a>
					<span class="info">
						<span v-if="selectStartDate" class="from-text">{{ $t('datepicker.from') }}</span>
						<span v-if="selectStartDate" class="from-date"> {{ displayDateText(selectStartDate) }} </span>
						<span v-if="selectEndDate" class="to-text">{{ $t('datepicker.to') }}</span>
						<span v-if="selectEndDate" class="from-date"> {{ displayDateText(selectEndDate) }} </span>
					</span>
				</div>-->
				<div class="vhd-calendar-left">
					<div class="calendar-month">
						<a
							v-if="!singleCalendar"
							:class="disabledPreviousArrow(startMonthDate)"
							class="previous-arrow offset-2"
							@click="updateCalendar(-2)"
						>
							<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M.697 7.89L7.767.817l1.415 1.414L3.526 7.89l5.656 5.657-1.414 1.414-5.656-5.657H2.11L.697 7.89z" fill="#7F8BA1" fill-rule="evenodd"/></svg>
						</a>
						<a
							:class="disabledPreviousArrow(startMonthDate)"
							class="previous-arrow offset-1"
							@click="updateCalendar(-1)"
						>
							<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M.697 7.89L7.767.817l1.415 1.414L3.526 7.89l5.656 5.657-1.414 1.414-5.656-5.657H2.11L.697 7.89z" fill="#7F8BA1" fill-rule="evenodd"/></svg>
						</a>
						<a
							v-if="singleCalendar"
							:class="disabledPreviousArrow(startMonthDate)"
							class="previous-arrow"
							@click="updateCalendar(-1)"
						>
							<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M.697 7.89L7.767.817l1.415 1.414L3.526 7.89l5.656 5.657-1.414 1.414-5.656-5.657H2.11L.697 7.89z" fill="#7F8BA1" fill-rule="evenodd"/></svg>
						</a>
						<a
							v-if="singleCalendar"
							class="next-arrow"
							@click="updateCalendar(1)"
						>
							<!-- <IconArrowForward class="arrow" /> -->
							<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7.89 8.525h-.001l-5.657 5.657-1.414-1.414L6.475 7.11.818 1.454 2.232.04l7.071 7.07L7.89 8.526z" fill="#7F8BA1" fill-rule="evenodd"/></svg>
						</a>
						<div class="calendar-month-title">
							{{ monthList[startMonthDate.getMonth()] }}
							{{ startMonthDate.getFullYear() }}
						</div>
						<a class="next-arrow offset-1" @click="updateCalendar(1)">
							<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7.89 8.525h-.001l-5.657 5.657-1.414-1.414L6.475 7.11.818 1.454 2.232.04l7.071 7.07L7.89 8.526z" fill="#7F8BA1" fill-rule="evenodd"/></svg>
						</a>
					</div>
					<div class="calendar-week">
						<div
							v-for="(wItem, index) in weekList"
							:key="index"
							class="calendar-week-item"
						>
							{{ wItem }}
						</div>
					</div>
					<div class="calendar-date">
						<div
							v-for="(week, wIndex) in startMonthAry"
							:key="wIndex"
							class="week"
						>
							<!-- För att visa veckonummer -->
							<div class="day week-number">v{{ getWeek(week, wIndex) }}</div>
							<div
								v-for="(startDay, dIndex) in week"
								:key="dIndex"
								:class="dayStatus(startDay)"
								class="day"
								@click="dayOnClick(startDay)"
							>
								<span v-if="startDay">{{ startDay.getDate() }}</span>
							</div>
						</div>
					</div>
				</div>
				<div v-if="!singleCalendar" class="vhd-calendar-right">
					<div class="calendar-month">
						<a class="next-arrow" @click="updateCalendar(2)">
							<!-- <IconArrowForward class="arrow" /> -->
							<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7.89 8.525h-.001l-5.657 5.657-1.414-1.414L6.475 7.11.818 1.454 2.232.04l7.071 7.07L7.89 8.526z" fill="#7F8BA1" fill-rule="evenodd"/></svg>
						</a>
						<div class="calendar-month-title">
							{{ monthList[endMonthDate.getMonth()] }}
							{{ endMonthDate.getFullYear() }}
						</div>
					</div>
					<div class="calendar-week">
						<div
							v-for="(wItem, index) in weekList"
							:key="index"
							class="calendar-week-item"
						>
							{{ wItem }}
						</div>
					</div>
					<div class="calendar-date">
						<div
							v-for="(week, wIndex) in endMonthAry"
							:key="wIndex"
							class="week"
						>
							<!-- För att visa veckonummer -->
							<div class="day week-number">v{{ getWeek(week, wIndex) }}</div>
							<div
								v-for="(endDay, dIndex) in week"
								:key="dIndex"
								:class="dayStatus(endDay)"
								class="day"
								@click="dayOnClick(endDay)"
							>
								<span v-if="endDay">{{ endDay.getDate() }}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="vhd-calendar-footer">
					<div v-if="!selectStartDate && !selectEndDate" class="helptext">
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"/><path d="M11 16h2v2h-2zM11 6h2v8h-2z"/></svg>
						<span>{{ startdateHelptext }}</span>
					</div>
					<div v-if="selectStartDate && !selectEndDate" class="helptext">
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"/><path d="M11 16h2v2h-2zM11 6h2v8h-2z"/></svg>
						<span>{{ enddateHelptext }}</span>
					</div>

					<Button
						:disabled="!selectStartDate"
						class="reset btn--dark"
						@click.native="reset"
						size="xsmall"
					>
						{{ $t('datepicker.reset') }}
					</Button>
					<!--<div
						v-if="selectStartDate && selectEndDate"
						class="confirm"
						@click="confirm"
					>{{ $t('datepicker.confirm') }}
					</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import Button from '../atoms/Button'
import 'moment-timezone'

export default {
	name: 'VueHotelDatepicker',
	components: {
		Button
	},
	directives: {},
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		separator: {
			type: String,
			default: '~'
		},
		format: {
			type: String,
			default: 'YYYY/MM/DD'
		},
		startDate: {
			type: [String, Date],
			default: undefined
		},
		endDate: {
			type: [String, Date],
			default: undefined
		},
		minDate: {
			type: [String, Date],
			default: () =>
				new Date(
					new Date().getFullYear(),
					new Date().getMonth(),
					new Date().getDate(),
					0,
					0,
					0
				)
		},
		maxDate: {
			type: [String, Date, Boolean],
			default: false
		},
		minNight: {
			type: Number,
			default: undefined
		},
		maxNight: {
			type: Number,
			default: undefined
		},
		selectForward: {
			type: Boolean,
			default: true
		},
		allowedDates: {
			type: Array,
			default: () => []
		},
		noDates: {
			type: Boolean,
			default: false
		},
		disabledDates: {
			type: Array,
			default: () => []
		},
		disabledWeekDays: {
			type: Array,
			default: () => []
		},
		weekList: {
			type: Array,
			default: () => ['M', 'T', 'O', 'T', 'F', 'L', 'S']
		},
		monthList: {
			type: Array,
			default: () => []
		},
		mobile: {
			type: String,
			default: '' // mobile or desktop
		},
		singleCalendar: {
			type: Boolean,
			default: false
		},
		singleDaySelection: {
			type: Boolean,
			default: false
		},
		dropdown: {
			type: Boolean,
			default: false
		},
		lightTheme: {
			type: Boolean,
			default: false
		},
		accordionTheme: {
			type: Boolean,
			default: false
		},
		startdateHelptext: {
			type: String,
			default: ''
		},
		enddateHelptext: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			value: '',
			startMonthDate: undefined,
			endMonthDate: undefined,
			selectStartDate: undefined,
			selectEndDate: undefined,
			selectMinDate: undefined,
			selectMaxDate: undefined,
			startMonthAry: [],
			endMonthAry: [],
			clickCount: 0
			// initialStartDate: this.startDate
		}
	},
	computed: {
		propStart: function () {
			return true
		}
	},
	watch: {
		maxDate(val) {
			if (val) {
				/*const maxDateValue = typeof val === 'string' ? val : val.getTime()
				this.selectMaxDate = new Date(maxDateValue)*/
				this.selectMaxDate = moment(val).toDate()
				this.updateValue()
				this.updateCalendar()
			} else {
				this.selectMaxDate = ''
			}
		},
		minDate(val) {
			if (val) {
				/*const minDateValue = typeof val === 'string' ? val : val.getTime()
				this.selectMinDate = new Date(minDateValue)*/
				this.selectMinDate = moment(val).toDate()
				this.updateValue()
				this.updateCalendar()
			}
		},
		startDate(val) {
			if (val) {
				/*const startDateValue = typeof val === 'string' ? val : val.getTime()
				this.selectStartDate = new Date(startDateValue)*/
				//Possible fix
				const startDateValue = moment(val).toDate()
				this.selectStartDate = startDateValue

				if (
					this.selectMinDate &&
					this.selectMinDate.getTime() > this.selectStartDate.getTime()
				) {
					//this.selectMinDate = new Date(startDateValue)
					this.selectMinDate = startDateValue
				}
			} else {
				this.selectStartDate = ''
			}
			// else {
			// 	const endDateValue =
			// 		typeof this.endDate === 'string'
			// 			? this.endDate
			// 			: this.endDate.getTime()
			// 	this.selectEndDate = new Date(endDateValue)
			// }
			this.updateValue()
			this.updateCalendar()
		},
		endDate(val) {
			if (val) {
				/*const endDateValue = typeof val === 'string' ? val : val.getTime()
				this.selectEndDate = new Date(endDateValue)*/
				this.selectEndDate = moment(val).toDate()
			} else {
				this.selectEndDate = ''
			}
			this.updateValue()
			this.updateCalendar()
		}
	},
	created() {
		if (this.minDate) {
			/*const minDateValue =
				typeof this.minDate === 'string' ? this.minDate : this.minDate.getTime()
			this.selectMinDate = new Date(minDateValue)*/

			this.selectMinDate = moment(this.minDate).toDate()
		}
		if (this.maxDate) {
			/*const maxDateValue =
				typeof this.maxDate === 'string' ? this.maxDate : this.maxDate.getTime()
			this.selectMaxDate = new Date(maxDateValue)*/
			this.selectMaxDate = moment(this.maxDate).toDate()
		}
		if (this.startDate) {
			const startDateValue =
				typeof this.startDate === 'string'
					? this.startDate
					: this.startDate.getTime()
			this.selectStartDate = moment(startDateValue).toDate()
			if (
				this.selectMinDate &&
				this.selectMinDate.getTime() > this.selectStartDate.getTime()
			) {
				this.selectMinDate = moment(startDateValue).toDate()
			}
			if (!this.endDate) {
				this.selectEndDate = new Date(
					this.selectStartDate.getTime() + 24 * 60 * 60 * 1000
				)
			} else {
				const endDateValue =
					typeof this.endDate === 'string'
						? this.endDate
						: this.endDate.getTime()
				this.selectEndDate = moment(endDateValue).toDate()
			}
			this.updateValue()
		}

		this.updateCalendar() // after setting

		// Set inital day status if there is values
	},
	mounted() {},
	methods: {
		//get the week nummbers
		getWeek(week, index) {
			const newWeek = week.filter(day => {
				if (day) {
					return day
				}
			})
			if (newWeek[index] != undefined) {
				return moment(newWeek[index], 'MM-DD-YYYY').isoWeek()
			}
			if (newWeek[newWeek.length - 1]) {
				return moment(newWeek[newWeek.length - 1], 'MM-DD-YYYY').isoWeek()
			}
		},
		reset() {
			this.selectStartDate = ''
			this.selectEndDate = ''
			this.value = ''
			this.$emit('reset')
		},
		confirm() {
			if (this.selectStartDate && !this.selectEndDate) {
				this.selectEndDate = moment(this.selectEndDate).toDate()
				this.selectEndDate.setDate(this.selectStartDate.getDate() + 1)
				this.updateValue()
			}
			if (this.selectStartDate && this.selectEndDate) {
				const dateResult = {
					start: this.displayDateText(this.selectStartDate),
					end: this.displayDateText(this.selectEndDate)
				}
				this.$emit('confirm', dateResult)
			}
		},
		displayDateText(datetime) {
			if (datetime) {
				datetime = typeof datetime === 'string' ? new Date(datetime) : datetime
				const yyyy = datetime.getFullYear()
				const mm =
					datetime.getMonth() + 1 > 9
						? datetime.getMonth() + 1
						: `0${datetime.getMonth() + 1}`
				const dd =
					datetime.getDate() > 9 ? datetime.getDate() : `0${datetime.getDate()}`
				const displayStr = (this.format || 'YYYY/MM/DD')
					.replace('YYYY', yyyy)
					.replace('MM', mm)
					.replace('DD', dd)
				return displayStr
			} else {
				return ''
			}
		},
		generateCalendarNew(activeDate) {
			let date = moment(activeDate).startOf('month')
			//let calenderFirstDay = moment(activeDate).startOf("isoWeek");
			let lastDayInMonth = moment(date).endOf('month')
			let endDate = moment(lastDayInMonth).add(1, 'day')
			let month = []
			let week = []
			let day = null
			/* eslint-disable */
			let counter = 0

			while (!date.isSame(endDate, 'day')) {
				counter++
				day = date.isoWeekday()
				week[day - 1] = moment(date).toDate()

				if (week.length === 7 || date.isSame(lastDayInMonth, 'd')) {
					month.push(week)
					week = []
				}
				date.add(1, 'd')
			}

			return month
		},
		updateCalendar(offset = 0) {
			if (!this.startMonthDate) {
				this.startMonthDate = this.selectStartDate
					? new Date(this.selectStartDate.getTime())
					: new Date(new Date().getFullYear(), new Date().getMonth()) // now
			}
			this.startMonthDate.setMonth(this.startMonthDate.getMonth() + offset)
			this.endMonthDate = new Date(
				this.startMonthDate.getFullYear(),
				this.startMonthDate.getMonth() + 1
			)
			this.startMonthAry = []
			this.endMonthAry = []
			this.startMonthAry = this.generateCalendarNew(this.startMonthDate)
			this.endMonthAry = this.generateCalendarNew(this.endMonthDate)
		},
		updateValue() {
			this.value = `${this.displayDateText(this.selectStartDate)} ${
				this.separator
			} ${this.displayDateText(this.selectEndDate)}`
		},
		disabledPreviousArrow(monthDatetime) {
			const now = new Date()
			const today = new Date(
				now.getFullYear(),
				now.getMonth(),
				now.getDate(),
				0,
				0,
				0
			)
			if (monthDatetime && this.selectForward) {
				if (this.selectMinDate) {
					if (monthDatetime.getFullYear() < this.selectMinDate.getFullYear()) {
						return 'disabled'
					}
					if (
						monthDatetime.getFullYear() === this.selectMinDate.getFullYear() &&
						monthDatetime.getMonth() <= this.selectMinDate.getMonth()
					) {
						return 'disabled'
					}
				} else {
					if (
						monthDatetime.getFullYear() === today.getFullYear() &&
						monthDatetime.getMonth() === today.getMonth()
					) {
						return 'disabled'
					}
				}
			}
		},
		dayStatus(datetime) {
			const classList = []

			if (datetime) {
				const now = new Date()
				// const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
				// check status
				if (moment(datetime).isoWeekday() === 7) {
					classList.push('holiday')
				}

				if (this.disabledWeekDays.indexOf(moment(datetime).isoWeekday()) > -1) {
					classList.push('disabledWeekDay')
				}
				if (
					this.allowedDates.length != 0 &&
					this.allowedDates.indexOf(this.displayDateText(datetime)) == -1
				) {
					classList.push('disabled')
					classList.push('forbidden')
				}

				if (this.noDates == true) {
					classList.push('disabled')
					classList.push('forbidden')
				}

				if (this.selectMinDate.getTime() > datetime.getTime()) {
					classList.push('disabled')
				} else if (
					this.selectMaxDate &&
					this.selectMaxDate.getTime() < datetime.getTime()
				) {
					classList.push('disabled')
				} else if (
					this.disabledDates.indexOf(this.displayDateText(datetime)) > -1
				) {
					classList.push('disabled')
					classList.push('forbidden')
				} else if (
					this.selectStartDate &&
					this.selectStartDate.getTime() > datetime.getTime() &&
					!this.selectForward &&
					!moment(this.selectStartDate).isSame(datetime, 'day')
					//!moment.tz(this.selectStartDate, 'UTC').isSame(moment.tz(datetime, 'UTC'), 'day')
				) {
					classList.push('disabled')
				} else if (
					this.selectStartDate &&
					//moment.tz(this.selectStartDate, 'UTC').isSame(moment.tz(datetime, 'UTC'), 'day')
					moment(this.selectStartDate).isSame(datetime, 'day')
				) {
					classList.push('start-date')
					if (this.singleDaySelection) {
						classList.push('start-end-date')
					}
				} else if (
					this.selectEndDate &&
					moment(this.selectEndDate).isSame(datetime, 'day')
					//moment.tz(this.selectEndDate, 'UTC').isSame(moment.tz(datetime, 'UTC'), 'day')
				) {
					if (!this.singleDaySelection) {
						classList.push('end-date')
					}
				} else if (
					this.selectStartDate &&
					this.selectEndDate &&
					datetime.getTime() > this.selectStartDate.getTime() &&
					datetime.getTime() < this.selectEndDate.getTime() &&
					!this.singleDaySelection
				) {
					classList.push('in-date-range')
				} else if (
					//Hacks to make the datepicker select the right day if you use singleday selecation
					this.selectStartDate &&
					this.selectEndDate &&
					datetime.getTime() + 24 * 60 * 60 * 1000 >
						this.selectStartDate.getTime() &&
					datetime.getTime() + 24 * 60 * 60 * 1000 <
						this.selectEndDate.getTime() &&
					this.singleDaySelection
				) {
					classList.push('start-end-date')
				}
				// check min night and max night
				if (
					this.selectStartDate &&
					((Number.isInteger(this.minNight) && this.minNight > 0) ||
						(Number.isInteger(this.maxNight) && this.maxNight > 0))
				) {
					const night =
						Math.abs(datetime.getTime() - this.selectStartDate.getTime()) /
						(1000 * 60 * 60 * 24)
					if (night < this.minNight) {
						classList.push('disabled')
					} else if (night > this.maxNight) {
						classList.push('disabled')
					}
				}
				// check today
				if (
					now.getFullYear() === datetime.getFullYear() &&
					now.getMonth() === datetime.getMonth() &&
					now.getDate() === datetime.getDate()
				) {
					classList.push('today')
				}
			}
			return classList
		},
		dayOnClick(datetime) {
			if (datetime) {
				if (!this.selectStartDate) {
					this.selectStartDate = datetime
				} else if (!this.selectEndDate) {
					if (
						this.selectStartDate &&
						datetime.getTime() < this.selectStartDate.getTime()
					) {
						this.selectEndDate = this.selectStartDate
						this.selectStartDate = datetime
					} else {
						this.selectEndDate = datetime
					}
				} else if (datetime.getTime() < this.selectStartDate.getTime()) {
					this.selectStartDate = datetime
				} else if (datetime.getTime() > this.selectEndDate.getTime()) {
					this.selectEndDate = datetime
				} else if (
					datetime.getTime() > this.selectStartDate.getTime() &&
					datetime.getTime() < this.selectEndDate.getTime()
				) {
					if (this.clickCount % 2 === 0) {
						this.selectStartDate = datetime
					} else {
						this.selectEndDate = datetime
					}
					this.clickCount++
				}
				if (this.singleDaySelection) {
					this.selectStartDate = datetime
					this.selectEndDate = ''
				}
				// check maxNight
				if (this.selectStartDate && this.selectEndDate && this.maxNight) {
					const limitDate =
						this.selectStartDate.getTime() + this.maxNight * 1000 * 60 * 60 * 24
					if (this.selectEndDate.getTime() > limitDate) {
						this.selectEndDate = new Date(limitDate)
					}
				}
				// check minNight
				if (this.selectStartDate && this.selectEndDate && this.minNight) {
					const limitDate =
						this.selectStartDate.getTime() + this.minNight * 1000 * 60 * 60 * 24
					if (this.selectEndDate.getTime() < limitDate) {
						this.selectEndDate = new Date(limitDate)
					}
				}

				const dateResult = {
					start: this.displayDateText(this.selectStartDate),
					end: this.displayDateText(this.selectEndDate)
				}
				this.$emit('update', dateResult)
				if (this.selectStartDate && this.selectEndDate) {
					this.updateValue()
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
//$calendar-boxsize: 38px;
$calendar-boxsize: 28px;

/*.day.week-number{
  position: absolute;
  position: absolute;
  transform: translate(-22px, 50%);
  font-size: 12px;
  color: #697791;
}
.calendar-date{
  width: 85%;
  margin-left: 15%;
}*/
@mixin mobile-vhd() {
	.vhd {
		&-picker {
			// width: 270px;
			width: 100%;
			max-width: 335px;
			padding: 8px;
			background-color: transparent;
		}
		&-calendar {
			&-header {
				height: 60px;
				> .info {
					display: block;
					width: 100%;
					height: 60px;
					padding-top: 36px;
				}
			}
			&-left {
				width: 100%;
				margin-right: 0;
			}
			&-right {
				display: none;
			}
			.calendar {
				&-month {
					.previous-arrow.offset-2 {
						display: none;
					}
					.previous-arrow.offset-1 {
						display: inline-block;
					}
					.next-arrow.offset-1 {
						display: inline-block;
					}
				}
				// &-week {
				// }
				&-date {
					.week {
						.day {
							//width: 14.2%;
							width: 12.2%;
							&.start-date {
								color: #ffffff;
								border-left: none;
								// background-color: #B2D7FF;
								//background-color: #0088ff;
								transition: all 0.2s ease;
							}
							&.end-date {
								color: #ffffff;
								border-right: none;
								// background-color: #B2D7FF;
								//background-color: #0088ff;
								transition: all 0.2s ease;
							}
						}
					}
				}
			}
		}
	}
}
* {
	box-sizing: border-box;
}

svg {
	fill: #7d7d7d;
	@media (hover: hover) {
		&:hover {
			fill: darken(#7d7d7d, 20%);
		}
	}
}
.vhd {
	&-container.mobile {
		@include mobile-vhd();
	}
	&-container {
		display: inline-block;
		width: 100%;
		max-width: 468px;
		position: relative;
		&--dropdown {
			position: absolute;
			top: 72px;
			left: 0;
			background: #fff;
			border: 1px solid #bfc5cf;
			border-top: 0;
			padding: 10px 10px 20px;
			width: 100%;
			z-index: 1;
			@include for-tablet-portrait-up {
				top: 62px;
			}
		}
	}
	&-input {
		min-width: 300px;
		padding: 8px;
		border: solid 1px #eeeeee;
		color: #505050;
		font-size: 16px;
		line-height: 32px;
		outline: none;
		&::placeholder {
			color: #cccccc;
		}
	}
	&-picker {
		z-index: 100;
		position: relative;
		left: 0;
		//width: 648px; //new
		width: 100%; //new
		// min-height: 300px;
		padding: 24px;
		background-color: #ffffff;
		// border: solid 1px #ececec;
		// border-radius: 6px;
		// box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
		overflow: hidden;
	}
	&-calendar {
		&-header {
			position: relative;
			width: 100%;
			height: 36px;
			> .info {
				display: inline-block;
				width: calc(100% - 24px);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				// .from-text {
				//
				// }
				.from-date,
				.to-date {
					margin: 0 8px;
					font-weight: 700;
				}
				// .to-text {
				//
				// }
			}
			> a.close {
				position: absolute;
				right: 0;
				width: 24px;
				height: 24px;
				cursor: pointer;
			}
		}
		&-footer {
			position: relative;
			width: 100%;
			// height: 80px;
			.reset,
			.confirm {
				margin: 8px 0;
				margin: 20px 0 0 0; //new
				/*position: absolute;
				bottom: -5px;
				margin: 8px 0;
				padding: 0 8px;
				font-weight: 500;
				text-decoration: underline;
				cursor: pointer;*/
			}
			.reset {
				width: 60px; //new
				float: right; //new
				top: 0;
				@media (hover: hover) {
					// &:hover {
					//color: $colorPrimary8;
					// }
				}
			}
			.confirm {
				right: 0;
				color: #0088ff;
				@media (hover: hover) {
					&:hover {
						color: darken(#0088ff, 20%);
					}
				}
			}
			.helptext {
				display: block;
				float: left;
				width: calc(100% - 80px);
				//max-width: 200px;
				background: #fff;
				border: 1px solid #e9ebef;
				color: #949eb1;
				font-size: 13px;
				font-weight: 400;
				padding: 4px 10px;
				margin: 20px 0 0 0;
				span {
					vertical-align: middle;
				}
				.icon {
					width: 18px;
					height: 18px;
					fill: $colorGreen;
					vertical-align: middle;
					margin-right: 7px;
				}
			}
		}
		&-left,
		&-right {
			display: inline-block;
			vertical-align: top;
			//width: 280px;
			width: auto;
		}
		&-left {
			margin-right: 20px;
		}
		.calendar {
			&-month {
				position: relative;
				height: 40px;
				//margin-bottom: 8px;
				background: #f4f5f7;
				.next-arrow,
				.previous-arrow {
					position: absolute;
					top: 0;
					padding-top: 4px;
					font-size: 0;
					width: 40px;
					height: 40px;
					display: inline-block;
					background-color: #f9fafb;
					padding: 14px 18px;
					color: #546482;
					// border: solid 1px #0088FF;
					cursor: pointer;
					&.disabled {
						// cursor: not-allowed;
						display: none !important;
					}
				}
				.previous-arrow {
					left: 0;
					margin-left: 0;
				}
				.next-arrow {
					right: 0;
				}
				.previous-arrow.offset-1 {
					display: none;
				}
				.next-arrow.offset-1 {
					display: none;
				}
				&-title {
					margin: 8px 0;
					font-size: 16px;
					font-weight: 400;
					line-height: 1.6;
					text-align: center;
					color: $colorPrimary8;
					padding-top: 8px;
				}
			}
			&-week {
				//width: 100%;
				//height: 32px;
				width: 100%;
				//height: $calendar-boxsize;
				height: 38px;
				border-bottom: 1px #e9ebef solid;
				padding: 7px 0;
				padding-left: 13%;
				border-bottom: 1px $colorPrimary1 solid;
				&-item {
					display: inline-block;
					font-size: 12px;
					font-weight: 500;
					//width: 14.2%;
					//width: 12.2%;
					width: 14.2%;
					height: 20px;
					color: $colorPrimary2;
					text-align: center;
					line-height: 20px;

					color: #949eb1;
					font-family: Saira;
					font-size: 12px;
					text-align: center;
				}
			}
			&-date {
				// background-color: #f4f5f7;
				.week {
					display: block;
					width: 100%;
					height: $calendar-boxsize;
					border-bottom: 1px $colorPrimary1 solid;
					.day {
						float: left;
						position: relative;
						display: inline-block;
						width: $calendar-boxsize;
						height: $calendar-boxsize;
						font-size: 16px;
						font-weight: 500;
						line-height: $calendar-boxsize;
						background-color: transparent;
						text-align: center;
						cursor: pointer;
						transition: background-color 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);

						color: #000000;
						font-family: Saira;
						font-size: 12px;

						span {
							width: calc(100% - 4px); //new
							height: 100%; //new
							display: inline-block; //new
							padding: 0 2px; //new
							border-bottom: 2px solid #04befb; //new
						}

						&::before,
						&::after {
							content: '';
							position: absolute;
							width: 0px;
							height: 100%;
							left: 0;
							background-color: transparent;
							opacity: 0;
							transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
								background-color 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
								width 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
						}
						&::after {
							left: auto;
							right: 0;
						}
						&.week-number {
							font-weight: normal;
							font-size: 12px;
							color: #697791;
							pointer-events: none;
						}
						&.disabled {
							color: $colorPrimary2;
							pointer-events: none;
							span {
								border-bottom: none; //new
							}
						}
						&.disabledWeekDay {
							color: $colorPrimary2;
							pointer-events: none;
						}
						&.in-date-range {
							background-color: $colorPrimary5;
							color: white;
						}
						/*&.start-end-date{
							border-radius: 20px;
							background-color: $colorPrimary5;
							color: white;
						}*/
						&.start-date {
							position: relative;
							background-color: $colorPrimary7;
							color: white !important;
							opacity: 1 !important; //new
							//border-radius: 20px 0 0 20px; //new
							// transition: all .2s ease;
							// &::before {
							// content: '';
							// position: absolute;
							// width: 4px;
							// height: 100%;
							// left: 0;
							// width: 4px;
							// background-color: #0088FF;
							// opacity: 1;
							// }
							span {
								border-bottom: none; //new
							}
						}
						&.end-date {
							position: relative;
							background-color: $colorPrimary7;
							color: white;
							opacity: 1 !important; //new
							//border-radius: 0 20px 20px 0; //new
							// transition: all .2s ease;
							// &::after {
							// content: '';
							// position: absolute;
							// width: 4px;
							// height: 100%;
							// width: 4px;
							// background-color: #0088FF;
							// opacity: 1;
							// transition: opacity .2s cubic-bezier(0.165, 0.84, 0.44, 1),
							//             background-color .2s cubic-bezier(0.165, 0.84, 0.44, 1),
							//             width .2s cubic-bezier(0.165, 0.84, 0.44, 1);
							// }
							span {
								border-bottom: none; //new
							}
						}
						&.start-end-date {
							// border-radius: 20px;
							background-color: $colorPrimary5;
							color: white;
						}
						&.today {
							// border: solid 1px $colorGrey4;
							font-weight: 800;
							color: $colorGrey7;
							&.disabled {
								color: $colorPrimary2;
							}
						}
						&.forbidden {
							color: #bfc5cf;
							cursor: not-allowed;
							span {
								border-bottom: none; //new
							}
						}
						&.forbidden.in-date-range {
							color: white;
						}
						&.holiday {
							color: $colorRed;
							&.disabled {
								color: $colorRed;
								opacity: 0.5;
							}
						}
					}
				}
			}
		}
	}
	&-container--single {
		.vhd-calendar-left {
			// width: 100%;
			max-width: 100%;
			margin-right: 0;
		}
		.vhd-calendar {
			//max-width: 224px;
		}
	}
	&-container--lightTheme {
		.vhd-calendar .calendar-month,
		.vhd-calendar .calendar-month .next-arrow,
		.vhd-calendar .calendar-month .previous-arrow,
		.vhd-calendar .calendar-week,
		.vhd-calendar .calendar-date {
			background: #fff;
		}
	}
	&-container--accordionTheme {
		.vhd-calendar .calendar-month .next-arrow,
		.vhd-calendar .calendar-month .previous-arrow {
			background: #e9ebef;
		}
		@include for-desktop-up {
			.vhd-calendar .calendar-month,
			.vhd-calendar .calendar-month .next-arrow,
			.vhd-calendar .calendar-month .previous-arrow,
			.vhd-calendar .calendar-week,
			.vhd-calendar .calendar-date {
				background: #fff;
			}
		}
	}
}
@media only screen and (max-width: 767.98px) {
	.vhd {
		&-container:not(.desktop) {
			@include mobile-vhd();
		}

		&-picker {
			padding: 0 !important;
		}
	}
}

@media only screen and (min-width: 767.98px) {
	.vhd {
		&-picker {
			padding: 0;
			//margin-left: -$spacing4;
			background-color: transparent;
		}

		.vhd-calendar-left {
			margin-right: 30px;
		}
	}

	.vhd-calendar-footer .confirm {
		right: 40px;
	}
}
</style>
